import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from "vue";
import Home from "./components/Home.vue";
import Manage from "./components/Manage.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let mode = window.location.search === "?mode=manage";

return (_ctx: any,_cache: any) => {
  return (_unref(mode) === false)
    ? (_openBlock(), _createBlock(Home, { key: 0 }))
    : (_openBlock(), _createBlock(Manage, { key: 1 }))
}
}

})